import { get, post } from 'api/request'

export const API_SALES = "/sales/service"

export const getStoreList = () => get(`${API_SALES}/store`)
